<template>
  <div class="row">
    <div class="col-xl-8 col-lg-12">
      <div class="card card-default">
        <form-wizard
          title="Openserve Connectivity"
          subtitle=""
          @on-complete="onComplete"
          stepSize="sm"
        >
          <tab-content
            title="Account Options"
            :before-change="() => validateStep('account-selection')"
          >
            <form novalidate data-vv-scope="account-selection">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    v-if="filledInSaleDefinition.requiredObjs.cappedService"
                    :class="{
                      'has-error': errors.has('account-selection.CapSize'),
                    }"
                  >
                    <label class="control-label">Cap Size *</label>
                    <div class="input-group">
                      <v-select
                        name="CapSize"
                        placeholder="Select Cap Size"
                        label="capSize"
                        v-model="packageSelected.selectedCapSize"
                        @input="onCapSizeChanged()"
                        :options="distinctCapSizes"
                      ></v-select>
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                    <span
                      class="has-error"
                      v-if="errors.has('account-selection.CapSize')"
                      >{{ errors.first("account-selection.CapSize") }}</span
                    >
                  </div>
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('account-selection.Speed'),
                    }"
                  >
                    <label class="control-label">Package *</label>
                    <div class="input-group">
                      <v-select
                        @input="getPackage"
                        v-validate="'verify_selected'"
                        ref="speed"
                        name="Speed"
                        placeholder="Select Package"
                        :get-option-label="getLabel"
                        :options="filterPackagesByCapSize"
                        v-model="packageSelected.package"
                      ></v-select>
                    </div>
                    <span
                      class="has-error"
                      v-if="errors.has('account-selection.Speed')"
                      >{{ errors.first("account-selection.Speed") }}</span
                    >
                  </div>
                </div>
              </div>
            </form>
          </tab-content>
          <tab-content
            title="Line Address Info"
            icon="fa fa-clipboard"
            :before-change="() => validateStep('line-info')"
          >
            <div class="row">
              <Address
                class="col-xl-12"
                @addressChanged="lineAddressChanged"
                @addressValid="lineAddressValidChanged"
                :addressStructure="
                  filledInSaleDefinition.requiredObjs.lineAddress
                "
                :addressTypes="
                  filledInSaleDefinition.supportingEnums.lineAddress.addressType
                "
              ></Address>
            </div>
          </tab-content>
        </form-wizard>
      </div>
    </div>
    <WizardCheckout 
      ref="wizardCheckoutModal"
      :description="packageSelected.description"
      :prices="packageSelected.selectedPrice"
      @checkout="finalize"
    />
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Address from "@/components/GeneralComponents/Address";
import WizardCheckout from '@/components/ObjParts/MultipleLoaded/WizardCheckout'

export default {
  components: {
    FormWizard,
    TabContent,
    WizardCheckout,
    Address,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filledInSaleDefinition: {
        selectableOptions: {
          connectivityPackage: [],
        },
        supportingEnums: {
          lineAddress: {
            addressType: [],
          },
          line: {},
        },
        requiredObjs: {
          pppoe: {},
          lineAddress: {
            addressType: [],
          },
        },
      },
      packageSelected: {
        description: "",
        selectedPrice: []
      },
      distinctCapSizes: [],
      filterPackagesByCapSize: [],
      shapedPools: [],
    };
  },
  created() {
    this.$validator.extend(
      "verify_selected",
      (value) => {
        return {
          valid:
            value ||
            (this.packageSelected &&
              this.packageSelected.connectivityPackageNumber),
          data: {
            required: true,
          },
        };
      },
      {
        computesRequired: true,
      }
    );
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
    this.getFilteredPackageList();
    const productNumber = this.filledInSaleDefinition.product.productNumber;
    this.$http
      .get(this.$config.aimsAPI + "shapedpools?productNumber=" + productNumber)
      .then(
        (response) => {
          this.shapedPools = response.body;
        },
        (error) => {
          this.showError("Error fetching Shaped Pools", error);
          console.error(error);
        }
      );
  },
  methods: {
    getFilteredPackageList() {
      this.distinctCapSizes = [];
      if (this.filledInSaleDefinition.requiredObjs.cappedService) {
        this.distinctCapSizes = [];
        this.filledInSaleDefinition.selectableOptions.connectivityPackage.forEach(
          (p) => {
            if (!this.distinctCapSizes.includes(p.size)) {
              this.distinctCapSizes.push(p.size);
            }
          }
        );
      } 
        const filteredPackageList = [];
        this.filledInSaleDefinition.selectableOptions.connectivityPackage.forEach(
          (p) => {
            filteredPackageList.push(p);
          }
        );

        const distinctSpeedList = this.distinctList(
          filteredPackageList,
          "connectivityPackageNumber"
        );

        const orderedlist = this.orderList(
          distinctSpeedList,
          "downloadSpeed"
        );
        

        //if there is a sku, then filter out all but the pre-selected objKey
        if (this.$route.query.sku) {
          let preSelectedObjKey = this.$route.query.sku.split('-',3)[2];
          var onlyOne = orderedlist.filter( pack => pack.connectivityPackageNumber == preSelectedObjKey);
          if (onlyOne.length == 1) {
            this.filterPackagesByCapSize = onlyOne;
            this.packageSelected = onlyOne[0]; 
          }
        } else {
          this.filterPackagesByCapSize = orderedlist;
        }
    },
    onCapSizeChanged() {
      const filteredPackageList = [];
      this.$refs.speed.clearSelection();
      this.filledInSaleDefinition.selectableOptions.connectivityPackage.forEach(
        (p) => {
          if (p.size === this.packageSelected.selectedCapSize) {
            filteredPackageList.push(p);
          }
        }
      );

      const distinctSpeedList = this.distinctList(
        filteredPackageList,
        "connectivityPackageNumber"
      );
      this.filterPackagesByCapSize = this.orderList(
        distinctSpeedList,
        "downloadSpeed"
      );
    },
    getLabel(option) {
      if (this.shapedPools.length > 0) {
        return (
          option.description +
          // " - [" +            //the description has all the details included it seems.
          // option.contractTerm +
          // "] - " +
          // this.speed_bitsToMbits(option.downloadSpeed) +
          // "/" +
          // this.speed_bitsToMbits(option.uploadSpeed) +
          " - [" +
          this.shapedPools.find(
            (sp) => sp.shapedPoolNumber === option.shapedPoolNumber
          ).name +
          "]"
        );
      }
    },
    getPrice(p) {
      return this.$http.get(
        this.$config.aimsAPI +
          "pricing/connectivitypackages/product/" +
          p +
          "?onlyCurrentPricing=true"
      );
    },
    async getPackage(packageSelected) {
      if (packageSelected && Object.keys(packageSelected).length > 0) {
        this.packageSelected = packageSelected;
        this.getPrice(packageSelected.productNumber).then((success) => {
          let prices = success.data.connectivitypackages;
          prices.forEach((price) => {
            if (
              price.connectivityPackageNumber ==
              packageSelected.connectivityPackageNumber
            ) {
              this.packageSelected.selectedPrice =
                price.connectivitypackageprices;
            }
          });
        });
      }
    },
    validateStep(stepName) {
      return this.$validator.validateAll(stepName).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
    onComplete() {
      if (this.filledInSaleDefinition.requiredObjs.cappedService) {
        this.filledInSaleDefinition.requiredObjs.cappedService.connectivityPackageNumber =
          this.packageSelected.connectivityPackageNumber;
      } else {
        this.filledInSaleDefinition.requiredObjs.uncappedService.connectivityPackageNumber =
          this.packageSelected.connectivityPackageNumber;
      }
      
      this.$refs.wizardCheckoutModal.open();
    },
    finalize(){
      this.$emit('createSale', this.filledInSaleDefinition);
    },
    lineAddressChanged(address) {
      this.filledInSaleDefinition.requiredObjs.lineAddress = address;
    },
    lineAddressValidChanged(isValid) {
      this.lineAddressValid = isValid;
    },
  },
};
</script>




      